import { invariant } from '@/shared/utils/typeAssertions'
import { useLimitedAction } from '../Billing/useLimitedAction'
import { useWorkspaces } from '../Workspaces/useWorkspaces'
import type { Field } from './Fields/types'
import { useEntity } from './useEntity'
import { useProjectStore } from './useProjectStore'

export const useFieldRecompute = () => {
  const workspacesStore = useWorkspaces()
  const projectStore = useProjectStore()
  const entityStore = useEntity()
  /**
   *
   * @param config.projectId - If not provided, project from the projectStore will be used
   */
  const recomputeField = async (field: Field, config?: { projectId?: string }) => {
    if (field.status === 'computing') return

    const projectId = config?.projectId || projectStore.projectId
    invariant(workspacesStore.currentWorkspace, 'No current workspace')
    invariant(projectId, 'No current project')

    const originalStatus = field.status
    const optimisticField = { ...field, status: 'computing' as const }

    entityStore.updateField(optimisticField)
    if (!config?.projectId) {
      projectStore.updateField(optimisticField)
    }

    const { recalculateEntity } = useLimitedAction()
    const res = await recalculateEntity({
      workspaceId: workspacesStore.currentWorkspace.id,
      projectId: projectId,
      entityId: field.entityId,
      propertyIds: [field.propertyId],
      force: true,
    })

    if (!res.ok) {
      const revertField = { ...field, status: originalStatus }
      entityStore.updateField(revertField)
      if (!config?.projectId) {
        projectStore.updateField(revertField)
      }
    }
  }

  return { recomputeField }
}
